import { FormattedMessage } from 'react-intl';

import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';

import messages from './PendingView.messages';
import styles from './PendingView.module.css';
import { Icon } from '@iwoca/orion';

const PendingView = () => {
    return (
        <MainSectionWrapper className={styles.wrapper}>
            <div className={styles.card}>
                <div className={styles.iconContainer}>
                    <Icon icon="clockFilled" className={styles.titleIcon} />
                </div>

                <div className={styles.title}>
                    <FormattedMessage {...messages.title} />
                </div>

                <div className={styles.bodyText}>
                    <FormattedMessage {...messages.description} />
                </div>
            </div>
        </MainSectionWrapper>
    );
};

// eslint-disable-next-line import/no-default-export
export default PendingView;
